import React from 'react';
import './seo.css';
import categoriesData from './categories.seo.json';
import { ISeoDictionaries } from './seo.models';

interface SeoProps {
  selectedGenders: string[];
  selectedClothes: string[];
  selectedTags: string[];
}

const Seo: React.FC<SeoProps> = ({ selectedGenders, selectedClothes, selectedTags }) => {
  const data: ISeoDictionaries = categoriesData;
  const clothesTypesToDisplay:string[]=["spodnice","tshirts","spodnie","sukienki","dlugi-rekaw","bluzy","kurtki","buty","swetry","dresy","bielizna","bizuteria"]

  const getDynamicSeoText = (): JSX.Element | null => {
    if (selectedGenders.length !== 1 || selectedClothes.length > 0 || selectedTags.length > 0) return null;

    const gender = selectedGenders[0];

    switch (gender) {
      case 'kobieta':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dla kobiet w jednym miejscu</h2>
            <div className="description-text">
            <b>Polskie ubrania dla kobiet</b> – odkryj <b>damskie ubrania szyte w Polsce</b> od lokalnych producentów, 
            którzy kładą duży nacisk na jakość i detale. Znajdziesz tu <b>marki odzieżowe tworzące ubrania 
            damskie petite </b> w stylu <b>basic</b>, które są idealne dla kobiet szukających modnej i komfortowej odzieży. 
            Prezentujemy <b>sukienki szyte w Polsce</b>, <b>damskie t-shirty szyte w Polsce</b>, <b>bielizna damska 
            szyta w Polsce</b> oraz inne <b>ubrania damskie</b>, które są produkowane z dbałością o detale i 
            z wykorzystaniem naturalnych materiałów. Nasze <b>polskie marki odzieżowe</b> oferują 
            wysokiej jakości produkty, które są nie tylko modne, ale również wygodne i trwałe. Dodatkowo, 
            prezentujemy <b>biżuterię polskich marek</b> oraz akcesoria tworzone w Polsce, które są doskonałym 
            uzupełnieniem Twojej garderoby. W Szafie Polskiej stawiamy na <b>polską modę</b> i <b>lokalnych producentów</b>, którzy tworzą ubrania z pasją i zaangażowaniem.
          </div>
          </>
        );
      case 'mezczyzna':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dla mężczyzn w jednym miejscu</h2>
            <div className="description-text">
              <b>Polskie ubrania dla mężczyzn</b> – odkryj katalog marek, w którym znajdziesz <b>odzież męską szytą w Polsce</b>. 
              W naszej selekcji prezentujemy <b>polskie bluzy męskie</b>, wygodne <b>męskie spodnie szyte w Polsce</b>, 
              unikalne <b>polskie t-shirty męskie</b> oraz komfortowe <b>dresy wyprodukowane w Polsce</b>. To także 
              idealne miejsce, by znaleźć <b>męskie buty polskich marek</b>, które dopełnią każdą stylizację. 
              Niezależnie od tego, czy Twoim celem są <b>basicowe ubrania męskie</b> na co dzień, czy <b>elegancka 
              odzież męska</b>, nasz katalog pomoże Ci znaleźć odpowiednie produkty. Każda <b>polska marka 
              odzieżowa dla mężczyzn</b> w naszym zestawieniu kładzie nacisk na wysoką jakość materiałów i 
              precyzję wykonania. Wspieraj lokalnych producentów i ciesz się modą tworzoną z pasją w Polsce.
            </div>
          </>
        );
      case 'dziecko':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dziecięce w jednym miejscu</h2>
          <div className="description-text">
            <b>Polskie marki odzieży dziecięcej</b> – w naszym katalogu znajdziesz wyselekcjonowane <b>ubrania dla 
            dzieci szyte w Polsce</b>. Szafa Polska to kompleksowy przewodnik po lokalnych producentach, którzy 
            z pasją projektują <b>modę dziecięcą</b>, kładąc nacisk na jakość, trwałość i bezpieczeństwo. 
            Prezentujemy <b>polskie marki odzieżowe dla dzieci</b>, które specjalizują się w różnorodnych 
            kategoriach. Odkryj producentów, którzy tworzą wygodne <b>t-shirty dziecięce</b>, urocze <b>sukienki</b>, 
            praktyczne <b>legginsy dziecięce</b>, a także ciepłe <b>kurtki</b> i <b>swetry dziecięce</b> dobrej jakości, 
            idealne na każdą porę roku.
            <br/><br/>
            Nasz katalog to idealne miejsce dla rodziców poszukujących polskich firm produkujących <b>ubranka dla niemowląt</b>, w tym 
            miękkich body, pajacyków czy czapek, wykonanych z bezpiecznych dla skóry dziecka <b>naturalnych tkanin</b>. 
            Prezentujemy zarówno marki oferujące <b>tanie polskie ubrania dla dzieci</b>, jak i marki premium, 
            których produkty wyróżniają się unikalnym designem i dbałością o każdy detal. Niezależnie od 
            tego, czy szukasz odzieży codziennej, czy eleganckich ubranek dziecięcychna specjalne okazje, 
            nasz katalog pomoże Ci znaleźć odpowiednią polską markę. Wspieraj lokalną gospodarkę i 
            wybieraj <b>ubrania dziecięce wyprodukowane w Polsce</b> – to wybór świadomy i odpowiedzialny.
          </div>
          </>
        );
      default:
      return null;
    }
  };

  const dynamicSeoText = getDynamicSeoText();

  const getGeneralSeoText = (): JSX.Element => (
    <>
        <h2 className="sectionTitle">Polskie marki odzieżowe w jednym miejscu</h2>

        <div className="description-text">
          Kupuj lokalnie. Wspieraj polskich producentów ubrań. Wybierz polską markę!
        </div>
        <h3 className="general-seo-h">Dlaczego warto wybierać <strong>polskie marki odzieżowe</strong>?</h3>
        <div className="description-text">
          <strong>Polskie marki odzieżowe</strong> to nie tylko moda – to połączenie pasji, etyki i wysokiej jakości. 
          W dzisiejszym świecie, gdzie coraz więcej ludzi szuka produktów z „duchem miejsca”, <strong>ubrania szyte w 
            Polsce</strong> stają się kluczowym wyborem dla świadomych konsumentów. 
          Nasz portal to miejsce, gdzie odkrywasz najlepsze <strong>polskie marki odzieżowe</strong> – 
          od małych, rodzinnych firm po projektowe studio, które tworzą ubrania z myślą o Tobie i naszej ziemi.
        </div>

	      <h3 className="general-seo-h"><strong>Polska odzież</strong> – wysoka jakość i etyczna produkcja</h3>
        <div className="description-text">
          Dlaczego warto wybrać <strong>polską markę odzieżową</strong>? Po pierwsze – jakość. 
          Polscy producenci odzieży często dbają o każdy detal: wybierają trwałe tkaniny, 
          dbają o precyzję szycia i tworzą ubrania, które służą długo. 
          Po drugie – etyka: kupując <strong>ubrania szyte w Polsce</strong>, wspierasz lokalną gospodarkę, 
          tworzysz pracę dla swoich sąsiadów i redukujesz ślad węglowy 
          (krótszy łańcuch dostaw to mniej emisji CO₂).
        </div>

        <h3 className="general-seo-h"><strong>Odzież damska, męska i dziecięca</strong> od polskich producentów</h3>
        <div className="description-text">
          Nasza platforma łączy różnorodność – znajdziesz tu <strong>odzież damską polskich marek</strong> (od casualowych t-shirtów i spodni, 
          po eleganckie sukienki czy bieliznę), <strong>odzież męską szytą w 
            Polsce</strong> (komfortowe koszule, trwałe spodnie, swetry z charakterem) oraz 
          <strong>odzież dziecięcą produkowaną w Polsce</strong> – bezpieczną, miękką i idealną dla najmłodszych. 
          Każda <strong>polska marka odzieżowa</strong> na naszej liście ma swój unikalny styl – 
          czy szukasz minimalizmu, retro, czy stylu boho, znajdziesz coś dla siebie.
        </div>

        <h3 className="general-seo-h"><strong>Polskie marki odzieżowe</strong> – dla każdego budżetu i stylu</h3>
        <div className="description-text">
          Nie ma tu ograniczeń przy cenach: od <strong>polskich marek odzieżowych</strong> 
          z przystępnymi cenami (budżetowe kolekcje dla codzienności) po ekskluzywne marki premium, 
          które stają się inwestycją na długi czas. Co więcej – wielu polskich producentów odzieży 
          otwarcie mówi o swoim procesie: dzielą się sekretami tkanin, technikami szycia i inspiracjami – 
          to <strong>transparentność</strong>, której szukasz w globalnych sieciach sklepowych.
        </div>

        <h3 className="general-seo-h"><strong>Świadoma moda z Polski</strong> – styl, który ma znaczenie</h3>
        <div className="description-text">
          Wybierając <strong>polskie ubrania</strong>, wybierasz więcej niż ubranie – wybierasz historię, ludzi i wartości. 
          To szansa, by być modnym, ale jednocześnie wspierać to, co jest blisko – lokalnych twórców, 
          ich marzenia i pasję do odzieży. Dołącz do tysięcy konsumentów, którzy 
          już <strong>wspierają polskich producentów ubrań</strong> – odkryj naszą kolekcję 
          i znajdź swoje ulubione <strong>polskie marki odzieżowe</strong>!
        </div>
    </>
  );

  const getStoresSeoText = (): JSX.Element => (
    <> <div>
        <b>Sklepy z polskimi ubraniami</b>
        <div className="stores-options">
          {data.stores.map((category, index) => (
            <div className="item" key={category.name} aria-label={category.ariaLabel}>
              {category.name}
              {index < data.stores.length - 1 ? (
                <span className="separator">• </span>
              ) : (
                <span className="separator">&nbsp;</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );

  return (
    <div className="seoSection">
      <div className="seoContent">
        <div className="column1">
          {dynamicSeoText && (dynamicSeoText)}
          {getGeneralSeoText()}
          {!dynamicSeoText && (getStoresSeoText())}
        </div>

        <div className="column2">
          {!dynamicSeoText && (
            <div className="seoGroup" data-test="gender">
              <h2 className="title">Polskie Ubrania Dla Ciebie i Twoich Bliskich</h2>
              {data.genders.map((category) => (
                <div className="option" key={category.code}>
                  <div className="option-title">
                    <a href={`/filtry/${category.code};g`}>
                      <b>{category.title}</b>
                    </a>
                  </div>
                  <div className="description">{category.seoGeneralDescription}</div>
                </div>
              ))}
            </div>
          )}

          <div className="seoGroup" data-test="clothesType">
          <h2 className="title">Filtruj polskie ubrania według typu</h2>
            <div className="clothes-options">
              {data.clothesTypes
                .filter((category) => clothesTypesToDisplay.includes(category.code))
                .map((category, index, filteredArray) => (
                  <div className="item" key={category.code}>
                    <a
                      href={`/filtry/${category.code};tc`}
                      className="option-title"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={category.ariaLabel}
                    >
                      {category.ariaLabel}
                    </a>
                    {index < filteredArray.length - 1 ? (
                      <span className="separator">• </span>
                    ) : (
                      <span className="separator">&nbsp;</span>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div className="seoGroup" data-test="tags">
            <h2 className="title">Znajdź polskie ubrania, jakich szukasz</h2>
            <div className="tags-options">
              {data.tags.map((category, index) => (
                <div className="item" key={category.code}>
                  <a
                    href={`/filtry/${category.code};t`}
                    className="option-title"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={category.ariaLabel}
                  >
                    {category.ariaLabel}
                  </a>
                  {index < data.tags.length - 1 ? (
                    <span className="separator">• </span>
                  ) : (
                    <span className="separator">&nbsp;</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seo;
